import {
  getDelegatedKeyAuthorizationSignatureTypedData as _getDelegatedKeyAuthorizationSignatureTypedData,
  // ?
  // getWalletAssociationSignatureTypedData as _getWalletAssociationSignatureTypedData,
  getWalletUnlockSignatureTypedData as _getWalletUnlockSignatureTypedData,
} from '@katanaperps/katana-perps-sdk';

import config from 'config';

const katanaEVMConfig = config.chains.katanaChain;

// https://github.com/idexio/idex-sdk-js-ikon/blob/beta/src/signatures.ts#L87

/** Used to revoke Delegated key, or Unlock wallet */
export const getWalletProofSignatureTypedData = async ({
  nonce,
}: {
  nonce: string;
}) => {
  return _getWalletUnlockSignatureTypedData(
    { nonce },
    katanaEVMConfig.exchangeContract,
    katanaEVMConfig.chainId,
    config.envIsSandbox
  );
};

export const getUnlockWalletSignatureTypedData = async ({
  nonce,
  delegatedKey,
}: {
  nonce: string;
  delegatedKey?: string;
}) => {
  return delegatedKey
    ? _getDelegatedKeyAuthorizationSignatureTypedData(
        {
          nonce,
          delegatedKey,
        },
        katanaEVMConfig.exchangeContract,
        katanaEVMConfig.chainId,
        config.envIsSandbox
      )
    : getWalletProofSignatureTypedData({ nonce });
};

// export const getWalletAssociationSignatureTypedData = async ({
//   nonce,
//   delegatedKey,
// }: {
//   nonce: string;
//   delegatedKey: string;
// }) => {
//   return _getWalletAssociationSignatureTypedData(
//     {
//       nonce,
//       wallet: delegatedKey,
//     },
//     katanaEVMConfig.exchangeContract,
//     katanaEVMConfig.chainId,
//     config.envIsSandbox
//   );
// };
